import PageContentAdmin from './PageContentAdmin';

const PrivacyAdmin = () => (
  <PageContentAdmin
    slug="privacy"
    label="Privacy Policy"
    publicPath="/privacy"
    helpText={
      <>
        Content is stored as HTML — you can use{' '}
        <code className="bg-gray-100 px-1 rounded">&lt;h2&gt;</code>,{' '}
        <code className="bg-gray-100 px-1 rounded">&lt;p&gt;</code>,{' '}
        <code className="bg-gray-100 px-1 rounded">&lt;strong&gt;</code>,{' '}
        <code className="bg-gray-100 px-1 rounded">&lt;ul&gt;/&lt;li&gt;</code>{' '}
        and{' '}
        <code className="bg-gray-100 px-1 rounded">&lt;a href=…&gt;</code>{' '}
        for external links (e.g. OAIC).
      </>
    }
  />
);

export default PrivacyAdmin;
